import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="docs-tooltip"
export default class extends Controller {
  static targets = ["trigger", "content"];

  connect() {
    this.close = this.close.bind(this);
    this.escClose = this.escClose.bind(this);
  }

  toggle(event) {
    event.stopPropagation();
    if (this.contentTarget.hidden) {
      this.show();
    } else {
      this.hide();
    }
  }

  show() {
    const rect = this.triggerTarget.getBoundingClientRect();
    this.contentTarget.style.top = rect.bottom + 6 + "px";
    this.contentTarget.style.left =
      Math.min(rect.left, window.innerWidth - 270) + "px";
    this.contentTarget.hidden = false;
    this.triggerTarget.setAttribute("aria-expanded", "true");
    document.addEventListener("click", this.close);
    document.addEventListener("keydown", this.escClose);
  }

  hide() {
    this.contentTarget.hidden = true;
    this.triggerTarget.setAttribute("aria-expanded", "false");
    document.removeEventListener("click", this.close);
    document.removeEventListener("keydown", this.escClose);
  }

  escClose(event) {
    if (event.key === "Escape") {
      this.hide();
    }
  }

  close(event) {
    if (!this.element.contains(event.target)) {
      this.hide();
    }
  }

  disconnect() {
    document.removeEventListener("click", this.close);
    document.removeEventListener("keydown", this.escClose);
  }
}
